export const farmsReducer = (state = {loading:true,result:null,farms:null,farm:null} , action) => {
    switch (action.type) {
        case 'FARM_SEND_SUCCESS':
            return {
                ...state,
                loading:false,
                result: action.payload
            }
        case 'FARMS_GET_SUCCESS':
            return {
                ...state,
                loading:false,
                farms: action.payload
            }
        case 'FARM_GET_DETAIL_SUCCESS':
            return {
                ...state,
                loading:false,
                farm: action.payload
            }
        case 'FARM_DELETE_SUCCESS':
            return {...state,
                loading:false,
                result: action.payload.message,
                farms: state.farms.filter(farm => farm._id !== action.payload.idFarm)
            }
        case 'FARM_DELETE_NOT_SUCCESS':
            return {...state,
                loading: false,
                result: action.payload
            }
        case 'FARM_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'FARM_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'FARM_ERROR':
            return {
                ...state,
                loading:false
            }
        default:
            return state
    }
}

